import { _ as _$1 } from '@swc/helpers/esm/_object_spread.js';
import { _ } from '@swc/helpers/esm/_object_without_properties.js';
import { cx } from '../../lib/cx.js';

function createAutocompleteComponent(param) {
    var createElement = param.createElement;
    return function Autocomplete(userProps) {
        var children = userProps.children, _userProps_classNames = userProps.classNames, classNames = _userProps_classNames === void 0 ? {} : _userProps_classNames, rootRef = userProps.rootRef, props = _(userProps, [
            "children",
            "classNames",
            "rootRef"
        ]);
        return /*#__PURE__*/ createElement("div", _$1({
            className: cx('ais-Autocomplete', classNames.root),
            ref: rootRef
        }, props), children);
    };
}

export { createAutocompleteComponent };
